import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Item from './Item';
import { postRequest } from '../../../Services/HttpService';
import { isNotDemo } from '../../../Services/DemoService';

interface IComponentProps {
  userSettingsKey: string;
  columns: any;
  tableName: string;
}

interface IStateProps {}

interface IComponentState {
  openMenu: boolean;
}

type Props = IComponentProps & IStateProps;
type State = IComponentState;

const TableSelectColumns = class extends React.PureComponent<Props, State> {
  state: Readonly<State> = {
    openMenu: false,
    // openRidebookMenu: false,
  };

  constructor(props: Props) {
    super(props);
    this.openList = this.openList.bind(this);
    // this.openRidebookMenu = this.openRidebookMenu.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleKeyboard = this.handleKeyboard.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, false);
    document.addEventListener('keydown', this.handleKeyboard, false);
  }

  componentDidUpdate(prevProps: Props) {
    const { openMenu } = this.state;
    const { columns } = this.props;
    const inputs = {
      columns: Object.values(columns)
        .filter((item: any) => item.visible)
        .map((item: any) => item.name),
    };
    const prevInputs = {
      columns: Object.values(prevProps.columns)
        .filter((item: any) => item.visible)
        .map((item: any) => item.name),
    };
    if (
      openMenu === true && // tslint:disable-line
      inputs.columns.length !== prevInputs.columns.length
    ) {
      if (isNotDemo()) {
        this.saveUserSettings(inputs);
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, false);
    document.removeEventListener('keydown', this.handleKeyboard, false);
  }

  handleKeyboard(event: any) {
    if (event.keyCode === 27) {
      this.setState({ openMenu: false });
    }
  }

  handleClickOutside(e: any) {
    if (
      e.target.id !== 'dropdownMenu1' &&
      e.target.className !== 'columnsCheckboxes' &&
      e.target.tagName !== 'SPAN' &&
      e.target.tagName !== 'I'
    ) {
      this.setState({ openMenu: false });
    }
    // if (e.target.id !== 'ridebookExportSelect' && e.target.tagName !== 'I') {
    //   this.setState({ openRidebookMenu: false });
    // }
  }

  async saveUserSettings(inputs: any) {
    const { userSettingsKey } = this.props;
    const link = `/v1/user-settings/${userSettingsKey}/save`;
    await postRequest(link, inputs, { showToaster: false });
  }

  openList() {
    const { openMenu } = this.state;
    this.setState({ openMenu: !openMenu });
  }

  // openRidebookMenu() {
  //   const { openRidebookMenu } = this.state;
  //   this.setState({ openRidebookMenu: !openRidebookMenu });
  // }

  render() {
    const { props, state } = this; // tslint:disable-line
    return [
      <div
        key="dropdownMenu1"
        className={`dropdown d-inline-block ml-xs mb-2 ${state.openMenu ? 'open' : ''}`}
        style={{ position: 'relative' }}
      >
        <button
          onClick={this.openList}
          data-cy="table-select-columns-choose"
          className="e-button dropdown-toggle ml-xs"
          type="button"
          id="dropdownMenu1"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
        >
          <FormattedMessage id="table.columnsChoosing" /> (
          {props.columns &&
            Object.keys(props.columns).filter(
              (i) => props.columns[i].system === false && props.columns[i].visible === true
            ).length}{' '}
          / {Object.keys(props.columns).filter((i) => props.columns[i].system === false).length}
          )
          <i className="cmd-icons cmd-icon-dropdown ml-2 fs-4" />
        </button>
        <div
          className="dropdown-menu dropdown-menu-custom fs-2"
          style={{ left: '5px', right: '0', overflow: 'auto', maxHeight: 'calc(100vh - 260px)' }}
          aria-labelledby="dropdownMenu1"
        >
          {Object.keys(props.columns).map((i) => (
            <Item
              key={`table-menu-item-${i}`}
              id={i}
              columnId={props.columns[i].name}
              title={props.columns[i].title}
              visible={props.columns[i].visible}
              required={props.columns[i].required}
              system={props.columns[i].system}
              tableName={props.tableName}
            />
          ))}
        </div>
      </div>,
    ];
  }
};

export default TableSelectColumns;
